import { motion } from 'framer-motion';

export default function ActionButtons({ onBack }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 2.5 }}
      className="sticky bottom-0 bg-slate-950/95 backdrop-blur-sm border-t border-white/10 px-6 py-4"
    >
      <div className="flex items-center justify-center">
        {onBack && (
          <button
            onClick={onBack}
            className="px-8 py-3 bg-blue-500 hover:bg-blue-600 text-white font-semibold rounded-lg shadow-lg shadow-blue-500/50 transition-all hover:shadow-xl hover:shadow-blue-500/70"
          >
            Finish Scenario
          </button>
        )}
      </div>
    </motion.div>
  );
}
